/**
 * 表示されたらフェードイン
 */
const targets = document.querySelectorAll('.inview');

// 要素があるときだけ処理を実行
if (targets.length) {
    const observer = new IntersectionObserver(
        (entries, obs) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    entry.target.classList.add('show');
                    obs.unobserve(entry.target);
                }
            });
        },
        {
            rootMargin: '0px 0px 10% 0px',
            threshold: 0.2,
        }
    );

    targets.forEach((el) => observer.observe(el));
}